(() => {
  if (window.zinkoSizeNavigationInstalled) return;
  window.zinkoSizeNavigationInstalled = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-zinko-size-target]');
    if (!link) return;
    const target = document.getElementById(link.dataset.zinkoSizeTarget);
    const current = link.closest('details.js-filter');
    if (!target || !current || target.closest('form') !== current.closest('form')) return;
    event.preventDefault();
    const summary = target.querySelector(':scope > summary');
    if (!summary) return;
    const drawer = current.closest('menu-drawer');
    if (drawer && typeof drawer.closeSubmenu === 'function') {
      drawer.closeSubmenu(current);
      window.setTimeout(() => {
        if (!target.isConnected || !drawer.mainDetailsToggle?.open) return;
        if (!target.open) {
          summary.click();
          target.open = true;
        }
      }, 450);
    } else {
      current.removeAttribute('open');
      current.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      target.open = true;
      summary.setAttribute('aria-expanded', 'true');
      if (summary.getClientRects().length) summary.focus();
      else target.querySelector('.zinko-size-navigation')?.focus();
    }
  });
})();
